import { fetchPageDataFactory } from 'actions/pageActionsV4';
import { AsyncStatus } from 'utils/asyncStatusHelper';
export var ImageReviewActions;
(function (ImageReviewActions) {
    ImageReviewActions["REQUEST"] = "GET_IMAGE_REVIEW_REQUEST";
    ImageReviewActions["SUCCESS"] = "GET_IMAGE_REVIEW_SUCCESS";
    ImageReviewActions["ERROR"] = "GET_IMAGE_REVIEW_ERROR";
})(ImageReviewActions || (ImageReviewActions = {}));
export const getImageReviewActualAction = fetchPageDataFactory(ImageReviewActions.REQUEST, ImageReviewActions.SUCCESS, ImageReviewActions.ERROR);
export const IMAGE_REVIEW_CACHE_TTL = 2 * 60 * 1000; // 2 minutes
export function resetImageGallery() {
    return {
        type: ImageGalleryActions.RESET
    };
}
export function getImageReviewAction(url, options, extraOptions) {
    return (dispatch, getState) => {
        const cachedFunction = getImageReviewActualAction(url, options, extraOptions);
        if (!extraOptions)
            return cachedFunction(dispatch);
        const state = getState();
        const { imageReviews } = state.ratingsAndReviews;
        const { imageId } = extraOptions;
        const review = imageReviews[imageId];
        // Check if review for given imageId already exists
        if (!review)
            return cachedFunction(dispatch);
        // If the review is already loading, resolve
        if (review.asyncStatus === AsyncStatus.LOADING) {
            return Promise.resolve(review);
        }
        // Check if the review is stale.
        // if it is not resolve
        if (review.asyncStatus === AsyncStatus.SUCCESS &&
            review.timestamp &&
            Date.now() - review.timestamp < IMAGE_REVIEW_CACHE_TTL) {
            return Promise.resolve(review);
        }
        return cachedFunction(dispatch);
    };
}
export var ImageGalleryActions;
(function (ImageGalleryActions) {
    ImageGalleryActions["REQUEST"] = "GET_IMAGE_GALLERY_REQUEST";
    ImageGalleryActions["SUCCESS"] = "GET_IMAGE_GALLERY_SUCCESS";
    ImageGalleryActions["ERROR"] = "GET_IMAGE_GALLERY_ERROR";
    ImageGalleryActions["POPULATE"] = "POPULATE_IMAGE_GALLERY";
    ImageGalleryActions["RESET"] = "RESET_IMAGE_GALLERY";
})(ImageGalleryActions || (ImageGalleryActions = {}));
export const getImageGalleryAction = fetchPageDataFactory(ImageGalleryActions.REQUEST, ImageGalleryActions.SUCCESS, ImageGalleryActions.ERROR);
export function populateImageGallery(images, url) {
    return {
        url,
        type: ImageGalleryActions.POPULATE,
        images
    };
}
